import { CommonModule } from '@angular/common';
import * as i0 from "@angular/core";
export class UniverseQuartileChartModule {
}
UniverseQuartileChartModule.ɵfac = function UniverseQuartileChartModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || UniverseQuartileChartModule)(); };
UniverseQuartileChartModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: UniverseQuartileChartModule });
UniverseQuartileChartModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule] });
